<template>
  <section class="ad mx-auto flex justify-center relative flex-col-reverse lg:flex-row select-none w-full overflow-hidden">
    <MajorityUiMajorityLink
      class="absolute w-full h-full z-10"
      tracking-name="communityAdWithoutImage"
      tracking-type="community content"
      :to="url"
    />
    <div
      class="flex-grow flex justify-center items-center text-center lg:text-left uppercase font-druk font-medium text-biggest lg:text-display-12 leading-7 lg:leading-12 -tracking-01-em lg:tracking-02-em px-4 py-5 lg:px-12 lg:py-8 lg:w-1/2"
      :class="backgroundColor"
    >
      {{ text }}
    </div>
    <div class="flex relative lg:w-1/2 bg-middle-light">
      <figure class="w-full">
        <div
          class="svg w-full lg:w-5 h-10 lg:h-full -ml-px transform scale-105 absolute bottom-0 z-10"
          :class="backgroundColor"
        />
        <MajorityUiMajorityImage
          :src="img"
          alt="community image"
          lazy
          fade-in
          class="object-cover w-full h-full"
        />
      </figure>
    </div>
  </section>
</template>

<script>
import { BRAND_BACKGROUND_COLORS } from '@/utils/constants'
import { isDarkOrLightByElement } from '@/utils/contrast-calculator'
export default {
  props: {
    img: {
      type: String,
      required: true,
      default: ''
    },
    text: {
      type: String,
      required: true,
      default: ''
    },
    url: {
      type: String,
      required: true,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: 'bg-bright-yellow',
      validator: val => BRAND_BACKGROUND_COLORS.includes(val)
    }
  },
  data () {
    return {
      calculatedTextVariant: 'dark'
    }
  },
  computed: {
    textClass () {
      return this.calculatedTextVariant === 'light'
        ? 'text-white'
        : 'text-dark'
    }
  },
  mounted () {
    this.calculateTextVariant()
  },
  methods: {
    calculateTextVariant () {
      try {
        this.calculatedTextVariant = isDarkOrLightByElement(this.$refs.contentBox.querySelector('.content-box-background'))
      } catch (error) {
        this.calculatedTextVariant = 'dark'
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.ad {
    @screen lg {
        max-width: 700px;
        max-height: 220px;
    }
}

figure {
    min-height: 190px;
}

.svg {
    clip-path: polygon(100% 100%, 50% 0, 0 100%);

    @screen lg {
        clip-path: polygon(0 0, 100% 50%, 0 100%);
    }
}
</style>
